import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import CardCarousel from './CardCarousel';
import { playVideoAction } from '../actions/action-creators';
import SpecialOpsVideoSlide from './SpecialOpsVideoSlide';
import {
  statsMainType,
} from '../proptypes/special-ops';
import { ResponsiveImage } from '../design-system/Images';
import phrasesType from '../proptypes/phrases';

const SpecialOpsVideoCardCarousel = ({
  stats,
  sessions,
  specialOpsVideoUrl,
  noVideoSessionImageUrl,
  videosBeingProcessed,
  onSlideChange,
  phrases,
}) => {
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState(0);
  const videoEls = useRef([]);

  const saveVideoElRef = (videoEl) => {
    if (!videoEl) return;
    videoEls.current = ([...videoEls.current, videoEl]);
  };
  const onChange = (i) => {
    videoEls.current.forEach(vid => vid.pause());
    setSelectedItem(i);
    onSlideChange(i);
  };

  const handleVideoPlay = ({ target }) => {
    dispatch(playVideoAction({
      eventTarget: target,
      eventId: 'specialOpsScoreCardVideoPlay',
    }));
  };

  return (
    <CardCarousel
      className="special-ops-score-card-video-carousel"
      showThumbs={false}
      swipeable
      showArrows
      showStatus={false}
      onChange={onChange}
      swipeScrollTolerance={12}
      selectedItem={selectedItem}
    >
      {sessions.map((sessionId, index) => {
        const imageKey = `image-${index}`;

        return (
          sessionId ? (
            <SpecialOpsVideoSlide
              key={sessionId}
              sessionId={sessionId}
              setVideoRef={saveVideoElRef}
              stats={stats[selectedItem]}
              specialOpsVideoUrl={specialOpsVideoUrl}
              isVideoBeingProcessed={videosBeingProcessed[index]}
              onPlay={handleVideoPlay}
            />
          ) : (
            <ResponsiveImage key={imageKey} src={noVideoSessionImageUrl} alt={phrases.noVideo} />
          )
        );
      })}
    </CardCarousel>
  );
};

SpecialOpsVideoCardCarousel.defaultProps = {
  onSlideChange: () => { },
};

SpecialOpsVideoCardCarousel.propTypes = {
  stats: PropTypes.arrayOf(statsMainType).isRequired,
  sessions: PropTypes.arrayOf(PropTypes.string).isRequired,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  videosBeingProcessed: PropTypes.arrayOf(PropTypes.bool).isRequired,
  onSlideChange: PropTypes.func,
  noVideoSessionImageUrl: PropTypes.string.isRequired,
  phrases: phrasesType.isRequired,
};

export default SpecialOpsVideoCardCarousel;
